import PropTypes from 'prop-types';
import React from 'react';

import { Message, Spin } from './styles';

const SpinDot = ({ className, message }) => (
  <>
    <Spin
      className={`ant-spin-dot ant-spin-dot-spin ${className}`}
      data-testid="spin-dot-container"
    >
      <i className="ant-spin-dot-item" />
      <i className="ant-spin-dot-item" />
      <i className="ant-spin-dot-item" />
      <i className="ant-spin-dot-item" />
    </Spin>
    {message && <Message className={className}>{message}</Message>}
  </>
);

SpinDot.propTypes = {
  className: PropTypes.string,
  message: PropTypes.string,
};

SpinDot.defaultProps = {
  className: '',
  message: '',
};

export default SpinDot;
